import * as React from "react";
import {DEF} from "../../../const";
import Box from "@mui/material/Box";
import {useEffect} from "react";
import "./ErrorInfo.css"


export const ErrorInfoState = {
    msg: '',
    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
    timer: null,
}

export const ErrorInfo = (
    {
        state, // ErrorInfoState
        setState
    }
) => {
    useEffect(() => {
        if(state.timer) {
            clearTimeout(state.timer);
        }
        if (DEF.POPUP_SHOWING_MANUAL_CLOSE !== state.show)
        {
            if (state.msg) {
                const timer = setTimeout(() => {
                    setState(ErrorInfoState);
                }, state.show);
                setState(state => ({...state, timer: timer}));
            } else {
                setState(ErrorInfoState);
            }
        } else {
            if (!state.msg) {
                setState(ErrorInfoState);
            }
        }
    }, [state.msg]);

    return (
        <Box className='error-info'>
            <Box className='error-info-frame' role='error-info-frame'>
                {(DEF.POPUP_SHOWING_MANUAL_CLOSE === state.show) && (
                    <button className='button'
                        onClick={() => setState(state => ({...state, msg: ''}))}
                    >
                        x
                    </button>
                )}
                {state.msg}
            </Box>
        </Box>
    );
};

export default ErrorInfo;
